import React from 'react'
import useSWR from 'swr'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import StatTile from '../../shared/StatTile'

export default withTranslation()(function RolesStats({ t }) {
  const { data } = useSWR('user-mgmt/roles')
  const roles = data?.data ?? []

  const active = roles.filter((role) => (role.status ?? 'active') !== 'inactive').length
  const usersAssigned = roles.reduce((sum, role) => sum + (role.users_count ?? 0), 0)

  return (
    <div className="grid gap-4 md:grid-cols-3 mb-5">
      <StatTile
        icon={UIcons.UilShieldCheck}
        label={t('settings.role_management.stats.total')}
        value={roles.length}
        tone="neutral"
        tinted
      />

      <StatTile
        icon={UIcons.UilCheckCircle}
        label={t('settings.role_management.stats.active')}
        value={active}
        tone="success"
        tinted
      />

      <StatTile
        icon={UIcons.UilUsersAlt}
        label={t('settings.role_management.stats.users_assigned')}
        value={usersAssigned}
        tone="purple"
        tinted
      />
    </div>
  )
})
